module.exports = __webpack_public_path__ + "edc4720836f0ef3d2e0e974d8f555a5c.jpg";